module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9QssS"))).then(() => parcelRequire('1iHdE'));